import { ActivityLiteModel } from 'api-hooks/activity';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { GuestLiteModel } from 'api-hooks/guest';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { PurchaseModel } from '../common/model';

export class ActivityPurchaseGuestDetailsModel {
  id: string;
  description: string;
  status: string;

  @Type(() => ActivityLiteModel)
  activity: ActivityLiteModel;

  @Type(() => Date)
  date: Date;

  @Type(() => Number)
  price: number;

  @Type(() => Number)
  qty: number;

  @Expose({ name: 'total_price' })
  @Type(() => Number)
  totalPrice: number;
}

export class ActivityPurchaseGuestsModel {
  id: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Expose({ name: 'activity_purchase_guest_details' })
  @Type(() => ActivityPurchaseGuestDetailsModel)
  activityPurchaseGuestDetails: ActivityPurchaseGuestDetailsModel[];
}

export class ActivityPurchaseAddOnsModel extends CommonModel {
  description: string;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  @Type(() => Number)
  price: number;
}

export class ActivityPurchaseItemModel {
  id: string;

  @Expose({ name: 'is_grouped_price' })
  isGroupedPrice: boolean;

  @Expose({ name: 'activity_purchase_guests' })
  @Type(() => ActivityPurchaseGuestsModel)
  activityPurchaseGuests: ActivityPurchaseGuestsModel[];

  @Expose({ name: 'activity_purchase_add_ons' })
  @Type(() => ActivityPurchaseAddOnsModel)
  activityPurchaseAddOns: ActivityPurchaseAddOnsModel[];
}

export class ActivityPurchaseLiteModel extends CommonModel {
  code: string;
  description: string;
  agent: string;
  number: string;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Expose({ name: 'payment_channel' })
  paymentChannel: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;
}

export class ActivityPurchaseModel extends PurchaseModel {
  @Expose({ name: 'activity_purchases' })
  @Type(() => ActivityPurchaseItemModel)
  activityPurchases: ActivityPurchaseItemModel[];
}

export type getActivityPurchasesInput = {
  params: CommonParamInput;
};

export type getActivityPurchaseInput = {
  id: string;
};

export type ActivityPurchaseGuestDetailsInput = {
  activityId: string | null;
  price: number;
  description: string;
};

export type ActivityPurchaseGuestsInput = {
  guestId: string | null;
  activityPurchaseGuestDetails: ActivityPurchaseGuestDetailsInput[];
};

export type ActivityPurchaseItemInput = {
  isGroupedPrice: boolean;
  activityPurchaseGuests: ActivityPurchaseGuestsInput[];
};

export type ActivityPurchaseMutationInput = {
  code: string;
  description: string;
  transactionAt: Date | null;
  tourRefId: string | null;
  invoiceNumber?: string;
  agentId: string | null;
  paymentChannelId: string | null;
  discount: number;
  otherCost: number;
  total: number;
  activityPurchases: ActivityPurchaseItemInput[];
  parentRefId?: string | null;
};

export type ActivityPurchaseUpdateInput = {
  activityPurchaseId: string;
  body: ActivityPurchaseMutationInput;
};

export type ActivityPurchaseDeleteInput = {
  activityPurchaseId: string;
};
